<template>
  <div>

    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">区块链农村三资监管平台</p>
              <p class="text">通过区块链汇集农村“三资”基础信息，统一各“三资”系统操作人员的区块链身份，建立标准的“三资”数字凭证，通过智能合约实现对“三资”管理中的违规事项进行预警和报警。实现对“三资”领域“人”、“物”、“事”的贯穿式监管</p>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/solution/part1-4.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="tit">方案介绍</p>
            <div class="content">
              <div class="line">
                恒为信息科技将区块链技术应用于农村“三资”监管领域，整合“三资”监管领域的多套应用系统，形成一套完整可信的“三资”基础数据。通过区块链账户，为各系统中的人员建立统一的区块链身份，同一个人员在不同系统的操作行为，将在链上留下完整的行为痕迹，从而实现对“三资”监管中“人”的穿透式监管。通过区块链可信数字凭证，将资产、资源、资金数字凭证化，数字凭证在不同系统间的转化均在链上存证，从而实现了对三资监管中“物”的全生命周期管理。基于完整可信的数据存证和公开透明的智能合约，能够准确地分析出“三资”管理中存在的异常信息，为农村基层工作人员提供办事提醒，为“三资”领域的监管人员提供监督预警和报警。基于“人”的贯穿式行为留痕，和“物”的全生命周期管理，能够为“三资”领域问题的线上核查提供完整的、不可篡改的依据，大大提高问题核查能力与效率，从而实现对“三资”管理过程中权力运行的有效监管。
              </div>
              <div class="img">
                <img
                  src="../../../assets/images/pc/solution/countryside/part2.png"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div class="part-3">
          <div class="main">
            <p class="tit">方案价值</p>
            <div class="content">
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/countryside/part3-1.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">基层管理人员受益</p>
                  <p class="txt">基于全面的“三资”信息和智能合约提醒机制，大大提高“三资”管理工作效率，避免工作中的疏忽为集体资产造成巨大的损失</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/countryside/part3-2.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">监管部门受益</p>
                  <p class="txt">基于准确完整的“三资”信息，能够全面掌握各村集体的“三资”管理情况，针对管理过程中存在的违规行为，能够及时察觉，高效核查</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/countryside/part3-3.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">群众受益</p>
                  <p class="txt">基于区块链公开透明、不可篡改的特点，透明清晰地了解集体资产状态和使用情况，发挥群众监督的作用，维护人民群众的利益</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="part-4">
          <div class="main">
            <p class="tit">应用案例</p>
            <div class="content">
              <swiper
                ref="mySwiper"
                :options="swiperOptions"
              >
                <swiper-slide>
                  <div class="card">
                    <div class="left">
                      <img
                        src="../../../assets/images/pc/solution/countryside/part4-11.png"
                        alt=""
                      >
                    </div>
                    <div class="right">
                      <p class="l1">苏州相城区三资监管链</p>
                      <div class="l2">
                        苏州相城区利用现有“三资”信息化系统，以不重复建设系统，不大规模改造现有系统，不增加使用人员负担的方式，通过“三资链”建立起完整可信的“三资”账本数据。基于这份账本数据，实现了对“三资”领域“人”、“物”、“事”的贯穿式监管，将现有孤立的“三资”数据发挥出最大的价值。辅助“三资”基层人员更好地管理“三资”，帮助区农业农村局和区纪委实现三资管理工作的监督和再监督。
                      </div>
                      <!-- <div class="l3">
                        <span class="s1">合作方：</span>
                        <img
                          src="../../../assets/images/pc/solution/countryside/part4-12.png"
                          alt=""
                        >
                        <span class="s2">呈信区块链科技（云南）有限责任公司 </span>
                        <span class="s3">上线时间：2019年6月</span>

                      </div> -->
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div
                class="swiper-pagination"
                slot="pagination"
              ></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cn: false,
      en: false,
      swiperOptions: {
        //swiper配置
        //autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //分页控制切换
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(-30deg, #019edf, #1cc8e7);
    .main {
      .clearfix();
    }
    .left {
      width: 54%;
      float: left;
      .tit {
        .hTit();
        margin: 185px 0 25px 0;
      }
      .text {
        width: 510px;
        .hText();
      }
    }
    .right {
      width: 46%;
      float: left;
      img {
        margin: 82px 0 0 75px;
        width: 440px;
        height: 351px;
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      height: 100%;
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        height: 100%;
        .line {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 15px;
        }
        .img {
          margin-top: 35px;
          text-align: center;
          img {
            width: 872px;
            height: auto;
          }
        }
      }
    }
  }

  .part-3 {
    padding: 80px 0 80px;
    background: #f9f9f9;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        .card {
          width: 1140px;
          height: 184px;
          display: flex;
          padding: 38px 20px;
          background: #ffffff;
          margin: 15px auto;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .left {
            width: 179px;
            img {
              height: 100%;
              height: 108px;
            }
          }
          .right {
            padding: 25px 0 0 20px;

            .title {
              color: #444444;
              font-size: 20px;
              text-align: left;
              margin-bottom: 4px;
            }
            .txt {
              color: #888888;
              text-align: left;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .part-4 {
    padding: 80px 0 80px;
    background: #ffffff;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .card {
          height: 332px;
          background: #fff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          margin: 10px;
          padding: 10px;
          display: flex;
          .left {
            width: 447px;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .right {
            flex: 1;
            padding: 45px 42px 0 59px;
            .l1 {
              color: #444444;
              font-size: 20px;
            }
            .l2 {
              margin: 30px 0;
              color: #888888;
              font-size: 14px;
              line-height: 24px;
            }
            .l3 {
              color: #888888;
              font-size: 14px;
              height: 32px;
              span {
                display: inline-block;
                height: 32px;
                line-height: 32px;
              }
              img {
                vertical-align: top;
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }
              .s3 {
                margin-left: 30px;
              }
            }
          }
        }
        .swiper-pagination {
          position: static; //取消定位
          display: block;
          margin: 30px auto 0;
          /deep/.swiper-pagination-bullet {
            background: #d4d4d4;
            margin: 0 5px;
            opacity: 1;
            outline: none; //清除点击突出的边框
          }
          /deep/.swiper-pagination-bullet-active {
            background: #2a93ff;
            position: relative;
            top: -2px;
            width: 28px;
            height: 4px;
            border-radius: 5px;
            opacity: 1;
            outline: none;
          }
        }
      }
    }
  }
}
</style>